import React, { useEffect, useState } from 'react';
import { paymentSecurityApprove } from '../../store/actions/auth';
import { CircularProgress } from '@material-ui/core';
import { useNavigate } from 'react-router-dom';
import '../login/login.css';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';

const PaymentSecurity = (props) => {
    const { request } = props;
    const [status, setStatus] = useState('loading'); // loading | success | error
    const [message, setMessage] = useState('');
    const [details, setDetails] = useState(null);
    const navigate = useNavigate();
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');

    const action = request?.action;
    const isApprove = action === 'approve';
    useEffect(() => {
        if (!token) {
            navigate('/');
            return;
        }

        processPayment();
    }, []);

    const processPayment = async () => {
        try {
            const response = await paymentSecurityApprove(action, token);
            if (response?.data?.Status === 200) {
                setDetails(response?.data);
                setStatus('success');
                setMessage(
                    action === 'approve'
                        ? 'Request has been approved successfully.'
                        : 'Request has been rejected.'
                );
                toast.success(response?.data?.Message?.AppStatusDescription || `Request has been ${action}d successfully.`);
            } else {
                setStatus('error');
                setMessage(response?.data?.Message?.AppStatusDescription || `Failed to ${action} the request. Please try again.`);
                toast.error(response?.data?.Message?.AppStatusDescription || `Failed to ${action} the request. Please try again.`);
            }
        } catch (err) {
            setStatus('error');
            setMessage(
                err?.data?.Message?.AppStatusDescription ||
                'Something went wrong. Please try again or contact support.'
            );
        }
    };

    return (
        <main>
            <div className="ps-page">
                <div className="ps-card">
                    {/* Logo */}
                    <div className="ps-logo-wrapper"></div>

                    {/* Loading State */}
                    {status === 'loading' && (
                        <div className="ps-content">
                            <CircularProgress disableShrink />
                            <h2 className="ps-heading mt-2">Processing your request...</h2>
                            <p className="ps-subtext">
                                Please wait while we updating your request.
                            </p>
                        </div>
                    )}

                    {/* Success State */}
                    {status === 'success' && (
                        <div className="ps-content">
                            <div className={`ps-icon-circle ${isApprove ? 'ps-icon-circle--approve' : 'ps-icon-circle--reject'}`}>
                                <span className={isApprove ? 'ps-icon--approve' : 'ps-icon--reject'}>
                                    {isApprove ? '✓' : '✕'}
                                </span>
                            </div>
                            <h2 className={`ps-heading ${isApprove ? 'ps-heading--approve' : 'ps-heading--reject'}`}>
                                {isApprove ? 'IP Approved' : 'IP Rejected'}
                            </h2>
                            <p className="ps-subtext">{message}</p>

                            {details && (
                                <div className="ps-details-box">
                                    {details.transactionId && (
                                        <div className="ps-detail-row">
                                            <span className="ps-detail-label">Transaction ID</span>
                                            <span className="ps-detail-value">{details.transactionId}</span>
                                        </div>
                                    )}
                                    {details.amount !== undefined && (
                                        <div className="ps-detail-row">
                                            <span className="ps-detail-label">Amount</span>
                                            <span className="ps-detail-value">${Number.parseFloat(details.amount).toFixed(2)}</span>
                                        </div>
                                    )}
                                    {details.requestedBy && (
                                        <div className="ps-detail-row">
                                            <span className="ps-detail-label">Requested By</span>
                                            <span className="ps-detail-value">{details.requestedBy}</span>
                                        </div>
                                    )}
                                    {details.date && (
                                        <div className="ps-detail-row">
                                            <span className="ps-detail-label">Date</span>
                                            <span className="ps-detail-value">{details.date}</span>
                                        </div>
                                    )}
                                </div>
                            )}

                            <p className="ps-note">
                                You may close this window. A confirmation email has been sent.
                            </p>
                        </div>
                    )}

                    {/* Error State */}
                    {status === 'error' && (
                        <div className="ps-content">
                            <div className="ps-icon-circle ps-icon-circle--error">
                                <span className="ps-icon--error">!</span>
                            </div>
                            <h2 className="ps-heading ps-heading--error">
                                Request Failed
                            </h2>
                            <p className="ps-subtext">{message}</p>
                            <p className="ps-note">
                                If the issue persists, please contact support or use the link from your email again.
                            </p>
                        </div>
                    )}

                    {/* Footer */}
                    <div className="ps-footer">
                        <p className="ps-footer-text">
                            This is an automated verification page. Do not share this link.
                        </p>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default PaymentSecurity;

PaymentSecurity.propTypes = {
    request: PropTypes.object,
};